import { defineStore } from 'pinia'
import locationApi from '@/api/location'

export const useLocationStore = defineStore('location', {
  state: () => ({
    locations: {}
  }),

  actions: {
    getLocations({ data, success, fail } = {}) {
      locationApi.getLocations(data).then(response => {
        this.locations = response.body.responseObject
        success && success(response)
      }, response => {
        fail && fail(response)
      })
    }
  },
})